import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["open", "onClose", "images", "item", "trigger", "onAddItem", "animation"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import { Icon, Grid } from 'semantic-ui-react';
import _isEmpty from 'lodash/isEmpty';
import LightboxImageDisplay from './components/LightboxImageDisplay';
import ItemInteraction from '../../../../organisms/FoodMenu/components/variants/item/ItemInteraction';
import { ImagesPropType } from '../../../../services/proptypes';
import { classNames } from '../../../../utils/classname';
import Modal from '../../../foundation/components/Modal';
import { DEFAULT_MODAL_ANIMATION } from '../../../foundation/components/Modal/Modal.constants';
import { ModalAnimationPropType } from '../../../foundation/components/Modal/Modal.types';
import { MenuCatalogItemPropType, MenuCatalogModifierSetPropType, MenuCatalogModifierPropType } from '../../types/menu-catalog';
import CatalogItemLightboxCart from '../CatalogItemCart/variants/CatalogItemLightboxCart';
import './CatalogItemLightbox.css';
var defaultProps = {
  trigger: null,
  images: [],
  modifierLists: [],
  modifiers: [],
  initialSelectedModifiers: [],
  initialSpecialInstructions: '',
  initialQuantity: 1,
  disabled: false,
  animation: DEFAULT_MODAL_ANIMATION
};
function CatalogItemLightbox(_ref) {
  var open = _ref.open,
    onClose = _ref.onClose,
    images = _ref.images,
    item = _ref.item,
    trigger = _ref.trigger,
    onAddItemProp = _ref.onAddItem,
    animation = _ref.animation,
    rest = _objectWithoutProperties(_ref, _excluded);
  function onAddItem(_x) {
    return _onAddItem.apply(this, arguments);
  }
  function _onAddItem() {
    _onAddItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(newItem) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return onAddItemProp(newItem);
          case 2:
            onClose();
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _onAddItem.apply(this, arguments);
  }
  var numColumns = _isEmpty(images) ? 1 : 2;
  return /*#__PURE__*/React.createElement(Modal, {
    className: classNames({
      'catalog-item-lightbox': true,
      'no-images': !images.length
    }),
    open: open,
    trigger: trigger,
    animation: animation,
    onClose: onClose
  }, /*#__PURE__*/React.createElement(Modal.Header, {
    className: "lightbox-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "close-icon-container"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "cancel",
    size: "large",
    onClick: onClose
  })), /*#__PURE__*/React.createElement("div", {
    className: "annotations-container"
  }, /*#__PURE__*/React.createElement(ItemInteraction, {
    item: item
  }))), /*#__PURE__*/React.createElement(Modal.Content, {
    scrolling: true,
    className: "lightbox-content"
  }, /*#__PURE__*/React.createElement(Grid, {
    doubling: true,
    stackable: true,
    columns: numColumns
  }, !_isEmpty(images) && /*#__PURE__*/React.createElement(Grid.Column, null, /*#__PURE__*/React.createElement(LightboxImageDisplay, {
    images: images
  })), /*#__PURE__*/React.createElement(Grid.Column, null, /*#__PURE__*/React.createElement(CatalogItemLightboxCart, _extends({
    item: item,
    onAddItem: onAddItem
  }, rest))))));
}
CatalogItemLightbox.defaultProps = defaultProps;
export default CatalogItemLightbox;